import { Box, Grid, Typography } from "@mui/material";
import moment from "moment";
import numeral from "numeral";

export const CreativeCard = ({
  creative,
  isLoggedIn,
  dfpMediaTitleLabels,
  classes,
}) => (
  <Grid
    key={creative.id}
    item
    xs={12}
    sm={12}
    md={12}
    className={classes.dfpCreativeWrapper}
    style={{
      opacity: creative.is_active === false ? 0.3 : 1,
    }}
  >
    <Grid container spacing={2}>
      <Grid item xs={3} sm={3} md={3}>
        <Box
          className={classes.imgBoxSquare}
          style={{
            backgroundImage: `url(${creative.image})`,
          }}
        />
      </Grid>
      <Grid item xs={9} sm={9} md={9}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Typography variant="h6" className={classes.dfpCreativeTitle}>
              {creative.media_title_codes?.map((mt) => (
                <span key={mt} className={classes.mediaTitleHeader}>
                  {dfpMediaTitleLabels[mt] || mt}
                </span>
              ))}
              {creative.is_active === false && (
                <span className={classes.mediaTitleHeader}>(paused)</span>
              )}
            </Typography>
            <Typography
              variant="h6"
              style={{
                fontFamily: "BatonTurbo-Book",
                fontSize: "16px",
                color: "#5e686c",
                fontWeight: "200",
                marginBottom: "16px",
              }}
            >
              {moment(creative.published_from).format("DD.MM.YYYY")} -{" "}
              {moment(creative.published_until).format("DD.MM.YYYY")}
            </Typography>
            <Typography variant="h6" className={classes.dfpCreativeTitle}>
              {isLoggedIn ? `ID ${creative.id}: ` : ""}
              {creative.title}
            </Typography>
            <Typography
              variant="body1"
              style={{
                fontSize: "14px",
                fontWeight: "200",
                maxWidth: "443px",
              }}
            >
              {creative.lead}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={classes.dfpMetricsWrapper}
          >
            <Typography variant="h6" className={classes.dfpMetricsKeyBold}>
              CTR:{" "}
            </Typography>
            <Typography variant="h6" className={classes.dfpMetricsValueBold}>
              {numeral(creative.ctr).format("0.000")}%
            </Typography>
            <Typography variant="h6" className={classes.dfpMetricsKey}>
              Impressions:{" "}
            </Typography>
            <Typography variant="h6" className={classes.dfpMetricsValue}>
              {numeral(creative.impressions).format()}
            </Typography>
            <Typography variant="h6" className={classes.dfpMetricsKey}>
              Clicks:{" "}
            </Typography>
            <Typography variant="h6" className={classes.dfpMetricsValue}>
              {numeral(creative.clicks).format()}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);
